import { jsx as a } from "react/jsx-runtime";
import { c } from "./clsx-OuTLNxxd.js";
import { forwardRef as x } from "react";
import { IconList as d } from "./components/elements/icon/iconsList.js";
const f = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, p = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl"
};
function u(e = 0) {
  const i = [];
  for (let s = 0; s < e; s++)
    i[s] = `path${s + 1}`;
  return i.map((s) => /* @__PURE__ */ a("span", { className: s }, s));
}
const y = x(
  ({ name: e, size: i = "medium", color: s = "base", className: n = "", ...t }, l) => {
    const r = d.find((m) => m.name === e), o = c("icon", `ds-${r == null ? void 0 : r.class}`, p[i], f[s], n);
    return /* @__PURE__ */ a("i", { className: o, ...t, ref: l, children: u(r == null ? void 0 : r.transform) });
  }
);
y.displayName = "Icon";
export {
  y as I,
  f as a,
  p as b
};
